import React from 'react';
import Images from "../../assets/images/images";

const PLAYSTORE_LINK = "https://play.google.com/store/apps/details?id=com.ediliziapp";

const PlayStoreLink = () => {

    const handleClick = () => {
        window.location.href = PLAYSTORE_LINK;
    }

    return (
        <img src={Images.playStore}
             alt='Play Store Link'
             onClick={handleClick}
             className="cursor-pointer bg-transparent px-1 rounded-lg hover:bg-ea_yellow w-48"/>
    );
};

export default PlayStoreLink;
